import DualPanelManageMembers from "./components/DualPanelManageMembers";
import { UsersAndCohortsList } from "./components/UsersAndCohorts";
import CohortListSkeleton from "./components/UsersAndCohorts/CohortListSkeleton";

export { CohortListSkeleton };

export default Object.assign(DualPanelManageMembers, {
  CohortList: UsersAndCohortsList,
  CohortListSkeleton,
});
